import { useStyles } from '@archipro-design/aria';
import * as S from './ProductCodes.style';

interface ProductCodesProps {
    sku?: string | null;
    barcode?: string | null;
}

const ProductCodes = ({ sku, barcode }: ProductCodesProps) => {
    const { css } = useStyles();

    return sku || barcode ? (
        <div className={css(S.ProductCodesContainer)}>
            {sku && <span title={sku}>SKU: {sku}</span>}
            {barcode && <span title={barcode}>Barcode: {barcode}</span>}
        </div>
    ) : null;
};

export default ProductCodes;
